import React, { useEffect, useState } from "react";

import { Info, Close } from "icons";
import { useLocation, useNavigate } from "react-router-dom";

import { login, oktaLogin, setUserSession } from "apis/authentication";
import { Button, Callout } from "clearsense-ui/components";
import useForceLightMode from "hooks/useForceLightMode";
import { LoginBg } from "images/LandingPage";

import Features from "./Features";
import LoginForm from "./LoginForm";
import ResetPassword from "./ResetPassword";

const Login = ({user}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isReset, setIsReset] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [response, setResponse] = useState("");
  const REDIRECT_URL = "/consumption";
  const isDevelopment = process.env.NODE_ENV === "development";

  // useEffect(() => {
  //   if (user) {
  //     navigate(redirectUrl);
  //   }
  // }, [user, navigate, redirectUrl]);

  const authenticateUser = async () => {
    // TODO: CHECK IF THIS IS ISSUE
    // if (isDevelopment) return login({ user: { email, password } });

    // If we successfully authenticate the user with Okta APIs
    // we send the response (session token etc) to our backend
    // so that devise can use this to handle user session etc normally
    const response = await oktaLogin({
      username: email,
      password: password,
      options: {
        multiOptionalFactorEnroll: false,
        warnBeforePasswordExpired: false,
      },
    });
    if (response?.data) await setUserSession(response?.data);
    return response;
  };

  useForceLightMode(!!user);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      // Logging the user in with devise/okta based on env
      const { data } = await authenticateUser();
      localStorage.setItem("user", email);
      localStorage.setItem("managementToken", data?.token);
      window.location.href = REDIRECT_URL;
      // const response = is_development_or_heroku_environment
      //   ? await login({ user: { email, password } })
      //   : await oktaLogin({
      //       username: email,
      //       password: password,
      //       options: {
      //         multiOptionalFactorEnroll: false,
      //         warnBeforePasswordExpired: false,
      //       },
      //     });

      // If we successfully authenticate the user with Okta APIs
      // we send the response (session token etc) to our backend
      // so that devise can use this to handle user session etc normally
      // if (!is_development_or_heroku_environment && response) {
      //   await setUserSession(response.data);
      // }
      window.location.href = REDIRECT_URL;
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) navigate(REDIRECT_URL);
  }, [user, navigate]);

  return (
    <div className="h-screen">
      {response === 200 && (
        <Callout icon={Info} className="absolute w-full">
          <div
            className="flex items-center justify-between w-full"
            data-cy="auth-callout-message"
          >
            Please check your mail for the instructions to reset your password.
            <Button style="text" icon={Close} onClick={() => setResponse(0)} />
          </div>
        </Callout>
      )}
      <div className="flex flex-row items-center justify-start w-screen h-full overflow-x-hidden overflow-y-auto ">
        <div className="w-full">
          <Features />
        </div>
        <div
          className="flex flex-col justify-center xl:w-1/3 lg:w-1/2 h-full px-10 items-left sm:max-w-md login-section bg-center bg-cover"
          style={{ backgroundImage: `url('${LoginBg}')` }}
        >
          <div className="w-full p-8 space-y-6 bg-white border rounded-md shadow">
            {isReset ? (
              <ResetPassword
                setIsReset={setIsReset}
                setResponse={setResponse}
              />
            ) : (
              <LoginForm
                email={email}
                setEmail={setEmail}
                password={password}
                setPassword={setPassword}
                handleSubmit={handleSubmit}
                loading={loading}
                setIsReset={setIsReset}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
